import { DateTransformPipe } from '@app/pipes/date-format.pipe';
import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { format } from 'date-fns';
import { environment } from '@environment';
import { LOCALES } from '@app/constants/locales.constanst';
import { CapitalizeAllPipe } from '@app/pipes/capitalize-all.pipe';

@Pipe({
  name: 'autoSearchDate',
  standalone: false
})
export class AutoSearchDatePipe implements PipeTransform {
  constructor(
    private datePipe: DatePipe,
    private dateTransformPipe: DateTransformPipe,
    private capitalizeAllPipe: CapitalizeAllPipe
  ) { }

  transform(value: Date, args?: string): string {
    const locale: Locale = LOCALES[environment.language.toLocaleLowerCase()];
    const dateFormat = locale?.localize ? 'eee, d MMM' : 'E, d MMM';
    const finalFormat = value ? locale?.localize ? format(value, dateFormat, { locale: locale }) :
      this.formatStringDate(this.datePipe.transform(value, dateFormat)) : '';
    return this.capitalizeAllPipe.transform(finalFormat);
  }

  private formatStringDate(date: string): string {
    return this.dateTransformPipe.transform(date);
  }
}
